export default __webpack_public_path__ + "static/media/bg_blue_bottom.72f8774f.png";